import { ComponentType, ReactNode } from "react";
import { Menu } from "lucide-react";
import { cn } from "@/app/_utils/cn";
import { useMobileNavStore } from "@/app/_store/mobileNavStore";

export default function PageHeader({
  title,
  subtitle,
  actions,
  icon: Icon,
  className,
}: {
  title: ReactNode;
  subtitle?: ReactNode;
  actions?: ReactNode;
  icon?: ComponentType<{ className?: string }>;
  className?: string;
}) {
  const toggleMobileNav = useMobileNavStore((s) => s.toggle);

  return (
    <div
      className={cn(
        "sticky top-0 z-10 flex items-center justify-between border-border bg-card/80 px-3 py-0.5 backdrop-blur-sm md:border-b md:bg-card md:px-5 md:backdrop-blur-none",
        className
      )}
    >
      <div className="flex min-w-0 items-center gap-2">
        {Icon && (
          <button
            type="button"
            onClick={toggleMobileNav}
            aria-label="Open navigation"
            className="-m-1 flex flex-none items-center rounded-md p-1 md:pointer-events-none md:cursor-default"
          >
            <Menu className="size-5 shrink-0 text-foreground md:hidden" size={20} />
            <Icon className="hidden size-5 shrink-0 text-foreground md:block" />
          </button>
        )}
        <h1 className="min-w-0 text-[20px] font-semibold leading-none tracking-tight text-foreground">
          {title}
        </h1>
        {subtitle && (
          <span className="min-w-0 truncate text-[13px] leading-none text-muted-foreground">
            {subtitle}
          </span>
        )}
      </div>
      {actions && <div className="flex flex-none items-center gap-2">{actions}</div>}
    </div>
  );
}
